import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
// import { getTodayTask, getDueDateTask } from './Redux/taskActions'
import ConvertContact from './ConvertContact'
import isEmpty from '../../utils/isEmpty'

const TaskCheckList = ({
  numberOfDueDateTasks,
  numberOfTodayTasks,
  selectedDueDate,
  isComplete,
  taskStatus,
  todayMeeting,
}) => {
  const taskStatusCompoennt = () => {
    return (
      <>
        {numberOfTodayTasks ? (
          <div>You have a task scheduled for {numberOfTodayTasks}</div>
        ) : (
          <div>No Scheduled tasks exist on this contact.</div>
        )}

        {selectedDueDate && (
          <div>
            Scheduled Tasks for {moment(selectedDueDate).format('MM/DD/YYYY')}: {numberOfDueDateTasks}
          </div>
        )}
        {!isEmpty(todayMeeting) && (
          <div>
            You have meeting scheduled with <strong>{todayMeeting.contactData.name}</strong>
            <NavLink to='/calendar' className='ml-3'>
              View Calendar
            </NavLink>
          </div>
        )}
      </>
    )
  }
  return (
    <>
      {!isComplete && taskStatusCompoennt()}
      {/* <div className="float-left w-50"> */}
      {isComplete && <ConvertContact taskStatus={taskStatus} dashComplete={isComplete} />}
      {/* </div> */}
    </>
  )
}

TaskCheckList.propTypes = {
  numberOfTodayTasks: PropTypes.string,
  numberOfDueDateTasks: PropTypes.string,
  selectedDueDate: PropTypes.string,
  isComplete: PropTypes.bool,
}

TaskCheckList.defaultProps = {
  numberOfDueDateTasks: '',
  numberOfTodayTasks: '',
  selectedDueDate: '',
  isComplete: false,
}

const mapStateToProps = (state) => {
  return {
    numberOfTodayTasks: state.Task.numberOfTodayTasks,
    numberOfDueDateTasks: state.Task.numberOfDueDateTasks,
    selectedDueDate: state.Task.data.dueDate,
    todayMeeting: state.Task.todayMeeting,
  }
}

export default connect(mapStateToProps, {})(TaskCheckList)
